import { Subject } from 'rxjs';
import * as _ from 'lodash';
import { ConfirmComponent } from '../../../components/catalogue/shared/confirm/confirm.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@ng-bootstrap/ng-bootstrap";
export class CommonDataService {
    constructor(http, modalService) {
        this.http = http;
        this.modalService = modalService;
        this.loaderStatus = new Subject();
        this.userData = {};
        this.setLoader = (val) => {
            this.loaderStatus.next(val);
        };
        this.convertToString = (obj) => {
            return _.cloneDeepWith(obj, (value) => {
                return !_.isPlainObject(value) ? _.toString(value) : undefined;
            });
        };
    }
    confirm(message, dialogSize) {
        const modalRef = this.modalService.open(ConfirmComponent, {
            size: dialogSize,
        });
        modalRef.componentInstance.message = message;
        return modalRef.result;
    }
}
CommonDataService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CommonDataService_Factory() { return new CommonDataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.NgbModal)); }, token: CommonDataService, providedIn: "root" });
